import React, { useState } from 'react';
import { create } from 'axios';
import { API_URL } from '../config';
const axios = create();
const inputStyle = {
  width: '100%',
  padding: '0.85rem 0.95rem',
  border: '1px solid #dbeafe',
  borderRadius: '10px',
  outline: 'none',
  boxSizing: 'border-box',
  fontSize: '0.95rem',
  backgroundColor: '#fbfdff',
};
const ContactUs = () => {
  const [isHuman, setIsHuman] = useState(false)
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!isHuman) {
      alert('Please complete the security check.')
      return
    }
    const form = e.target;
    const formData = new FormData(form);
    try {
      const response = await axios.post(`${API_URL}contactus.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log(response.data);
      form.reset();
      setIsHuman(false);
      alert('Message sent successfully!');
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Failed to send message. Please try again.');
    }

  }
  return (
    <section
      style={{
        padding: '3rem 1.5rem',
        background: 'linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%)',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '2rem',
          alignItems: 'center',
        }}
      >
        <div>
          <h2 style={{ marginBottom: '0.75rem', color: '#1f3d7a', fontSize: '2rem' }}>
            Contact Us
          </h2>
          <p style={{ lineHeight: 1.8, color: '#475569', marginBottom: '1rem' }}>
           We are here to walk beside you through every step of your fertility journey, offering guidance, care, and unwavering support. Whether you are just beginning to explore your options or are already undergoing treatment, our team is committed to providing compassionate consultations tailored to your unique needs. We understand that fertility challenges can feel overwhelming, but you don’t have to face them alone. With us, you’ll find a safe space to ask questions, receive clear information about treatments, and access resources designed to empower you in making informed decisions.
            Our specialists are dedicated to combining medical expertise with emotional understanding, ensuring that you feel supported not only physically but also mentally and emotionally. From initial assessments to advanced treatment plans, we strive to make the process as smooth and reassuring as possible. We believe that every journey is personal, and we are here to listen, guide, and stand by you at every stage.
            Reach out to us today for consultations, treatment information, or simply to talk through your concerns. Together, we can take meaningful steps toward your dream of building a family, with care and hope lighting the way forward.

          </p>
          <p style={{ margin: '0.25rem 0', color: '#334155' }}><strong>Phone:</strong> 📞 +91 97798 48111</p>
          <p style={{ margin: '0.25rem 0', color: '#334155' }}><strong>Email:</strong>✉️ ivfankur@gmail.com</p>
          <p style={{ margin: '0.25rem 0', color: '#334155' }}><strong>Address:</strong> 📍 Martyr Anil Baghi Road, Ferozepur City , Punjab 152002, BHARAT</p>
        </div>

        <form
          style={{
            background: '#ffffff',
            padding: '1.6rem',
            borderRadius: '18px',
            boxShadow: '0 18px 45px rgba(15, 44, 92, 0.10)',
            border: '1px solid #e7f0ff',
          }}
          onSubmit={handleSubmit}
        >
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.4rem', color: '#1f3d7a', fontWeight: 600, fontSize: '0.95rem' }}>Name</label>
            <input name="name" type="text" placeholder="Your Name" required style={inputStyle} />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.4rem', color: '#1f3d7a', fontWeight: 600, fontSize: '0.95rem' }}>Email</label>
            <input name="email" type="email" placeholder="Your Email" required style={inputStyle} />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.4rem', color: '#1f3d7a', fontWeight: 600, fontSize: '0.95rem' }}>Phone</label>
            <input
              name="phone"
              type="tel"
              placeholder="Your Phone"
              pattern="[6789][0-9]{9}"
              title="Please enter a 10-digit mobile number starting with 6, 7, 8 or 9"
              minLength="10"
              maxLength="10"
              inputMode="numeric"
              required
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.4rem', color: '#1f3d7a', fontWeight: 600, fontSize: '0.95rem' }}>City/State</label>
            <input name="city" type="text" placeholder="Your City/State" required style={inputStyle} />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.4rem', color: '#1f3d7a', fontWeight: 600, fontSize: '0.95rem' }}>Message</label>
            <textarea name="message" rows="4" placeholder="How can we help you?" required style={{ ...inputStyle, resize: 'vertical', minHeight: '110px' }} />
          </div>
          <div
            style={{
              marginBottom: '1rem',
              border: '1px solid #dcecff',
              borderRadius: '14px',
              padding: '0.95rem 1rem',
              background: 'linear-gradient(135deg, #ffffff 0%, #f6faff 100%)',
              boxShadow: '0 8px 24px rgba(31, 78, 154, 0.06)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.7rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.55rem' }}>
                <div style={{ width: '34px', height: '34px', borderRadius: '8px', background: 'linear-gradient(135deg, #1f4e9a 0%, #2b6ee0 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '0.95rem', fontWeight: 700 }}>
                  ✓
                </div>
                <div>
                  <div style={{ fontSize: '0.92rem', fontWeight: 700, color: '#1f3d7a' }}>Security Check</div>
                  <div style={{ fontSize: '0.8rem', color: '#64748b' }}>Complete verification to continue</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontWeight: 700, color: '#1f4e9a', fontSize: '0.9rem' }}>
                <span style={{ fontSize: '0.95rem' }}>◉</span>
                reCAPTCHA
              </div>
            </div>

            <div style={{ border: '1px solid #eaf2ff', borderRadius: '10px', background: '#fbfdff', padding: '0.8rem 0.9rem' }}>
              <label htmlFor="not-a-robot" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', color: '#334155', fontSize: '0.95rem', fontWeight: 600 }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6rem' }}>
                  <input
                    type="checkbox"
                    id="not-a-robot"
                    checked={isHuman}
                    onChange={() => setIsHuman(!isHuman)}
                    style={{ accentColor: '#2b6ee0', width: '16px', height: '16px' }}
                  />
                  I’m not a robot
                </span>
                <span style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: 500 }}>Protected by reCAPTCHA</span>
              </label>
            </div>
          </div>
          <button
            type="submit"
            disabled={!isHuman}
            style={{
              width: '100%',
              background: isHuman ? 'linear-gradient(135deg, #1f4e9a 0%, #2b6ee0 100%)' : '#cbd5e1',
              color: '#ffffff',
              border: 'none',
              padding: '0.9rem',
              borderRadius: '10px',
              cursor: isHuman ? 'pointer' : 'not-allowed',
              fontWeight: 600,
              fontSize: '0.98rem',
              boxShadow: isHuman ? '0 8px 20px rgba(43, 110, 224, 0.2)' : 'none',
              transition: 'all 0.2s ease',
            }}
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  )
}

/* inputStyle moved above component */

export default ContactUs
